export type EnablementProviderSlug = 'sgimed';

export type EnablementProviderConfig = {
  slug: EnablementProviderSlug;
  displayName: string;
};

export const ENABLEMENT_PROVIDERS: Record<
  EnablementProviderSlug,
  EnablementProviderConfig
> = {
  sgimed: {
    slug: 'sgimed',
    displayName: 'SGIMED',
  },
};

export const ENABLEMENT_PROVIDER_SLUGS = Object.keys(
  ENABLEMENT_PROVIDERS
) as EnablementProviderSlug[];

/** App Market enablement page for a registered partner (`?context=` / `?code=&state=`). */
export function partnerEnablementPath(slug: EnablementProviderSlug): string {
  return `/integration/${slug}/enable`;
}

/**
 * Public-route prefix for a partner's integration tree (enable + launch).
 * Middleware treats no-trailing-slash entries as `route` OR `${route}/…`.
 */
export function partnerEnablementPublicRoutePrefix(slug: EnablementProviderSlug): string {
  return `/integration/${slug}`;
}

export function getEnablementProvider(
  slug: string | undefined
): EnablementProviderConfig | null {
  if (!slug) return null;
  return ENABLEMENT_PROVIDERS[slug as EnablementProviderSlug] ?? null;
}
